"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styled_components_1 = require("styled-components");
var components_1 = require("react-sidenav/template/components");
var Scheme_1 = require("react-sidenav/types/Scheme");
var BASE_PADDING_LEFT = 12;
var PADDING_INCREMENT = 12;
var PADDING_RIGHT = BASE_PADDING_LEFT;
var createPadding = function (level) {
    var indent = (BASE_PADDING_LEFT + (level * PADDING_INCREMENT)) + "px";
    return "8px " + PADDING_RIGHT + "px 8px " + indent;
};
var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    transition: all 0.3s ease;\n    position: relative;\n    padding: ", ";\n    align-items: center;\n    justify-content: ", ";\n    cursor: pointer;\n    background: ", ";\n    color: ", ";\n    &:hover {\n        background: ", ";\n        color: ", ";\n    }\n"], ["\n    display: flex;\n    transition: all 0.3s ease;\n    position: relative;\n    padding: ", ";\n    align-items: center;\n    justify-content: ", ";\n    cursor: pointer;\n    background: ", ";\n    color: ", ";\n    &:hover {\n        background: ", ";\n        color: ", ";\n    }\n"])), function (props) { return createPadding(props.level); }, function (props) { return props.scheme === Scheme_1.Scheme.compact ? 'center' : 'flex-start'; }, function (props) { return props.selected ? props.theme.selectionBgColor : props.theme.bgColor || 'inherit'; }, function (props) { return props.selected ? props.theme.selectionColor : props.theme.color || 'inherit'; }, function (props) { return props.theme.hoverBgColor || props.theme.selectionBgColor; }, function (props) { return props.theme.hoverColor || props.theme.selectionColor; });
exports.ChildrenTemplate = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    max-height: ", ";\n    transition: all 0.3s ease-in-out;\n    overflow: hidden;\n"], ["\n    max-height: ", ";\n    transition: all 0.3s ease-in-out;\n    overflow: hidden;\n"])), function (props) { return props.expanded ? '1000px' : '0px'; });
var determineIconColor = function (props) {
    if (props.selected) {
        return props.theme.selectionIconColor || props.theme.selectionColor || 'inherit';
    }
    return 'inherit';
};
exports.IconView = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    color: ", ";\n    display: flex;\n    justify-content: center;\n    align-items: center;\n"], ["\n    color: ", ";\n    display: flex;\n    justify-content: center;\n    align-items: center;\n"])), function (props) { return determineIconColor(props); });
exports.IconText = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding-left: 8px;\n"], ["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding-left: 8px;\n"])));
var createProps = function (key, childProps) {
    var propsToUse = { key: key };
    if (childProps.className) {
        propsToUse.className = propsToUse.className;
    }
    if (childProps.children) {
        propsToUse.children = childProps.children;
    }
    return propsToUse;
};
var ArrowRight = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: inline-block;\n    border-right: 1px solid ", ";\n    border-bottom: 1px solid ", ";\n    width: 4px;\n    height: 4px;\n    transform: ", ";\n    transition: transform 0.3s ease;\n    position: absolute;\n    left: auto;\n    right: 0;\n    margin-right: 6px;\n"], ["\n    display: inline-block;\n    border-right: 1px solid ", ";\n    border-bottom: 1px solid ", ";\n    width: 4px;\n    height: 4px;\n    transform: ", ";\n    transition: transform 0.3s ease;\n    position: absolute;\n    left: auto;\n    right: 0;\n    margin-right: 6px;\n"])), function (props) { return props.theme.color || 'currentColor'; }, function (props) { return props.theme.color || 'currentColor'; }, function (props) { return props.expanded ? 'rotate(45deg)' : 'rotate(-45deg)'; });
var DefaultTemplate = /** @class */ (function (_super) {
    __extends(DefaultTemplate, _super);
    function DefaultTemplate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.remapChildren = function (partial, child, idx) {
            var _a = _this.props, elementChildren = _a.children, navTemplate = _a.template, className = _a.className, others = __rest(_a, ["children", "template", "className"]);
            var props = _this.props;
            var inav = __assign({}, others, { template: navTemplate });
            var asElementType = child;
            if (asElementType.type === components_1.NavIcon) {
                var NavIconTemplate = (navTemplate && navTemplate.icon ? navTemplate.icon : exports.IconView);
                var propsToUse = __assign({}, inav, createProps("" + idx, asElementType.props));
                partial.push(React.createElement(NavIconTemplate, propsToUse));
                return partial;
            }
            if (asElementType.type === components_1.NavText) {
                if (props.scheme !== Scheme_1.Scheme.compact) {
                    var NavTextTemplate = (navTemplate && navTemplate.text ? navTemplate.text : exports.IconText);
                    var propsToUse = __assign({}, inav, createProps("" + idx, asElementType.props));
                    partial.push(React.createElement(NavTextTemplate, propsToUse));
                    return partial;
                }
                return partial; // we need to return here to ensure it will not get added
            }
            partial.push(child);
            return partial;
        };
        return _this;
    }
    DefaultTemplate.prototype.render = function () {
        var _a = this.props, elementChildren = _a.children, navTemplate = _a.template, className = _a.className, others = __rest(_a, ["children", "template", "className"]);
        var inav = __assign({}, others, { template: navTemplate });
        var props = this.props;
        // remap children, to be sure they are on the same order
        var remappedChildren = React.Children.toArray(elementChildren).reduce(this.remapChildren, []);
        var IndicatorElement = props.isLeaf === false ? (exports.template.expandIndicator ? exports.template.expandIndicator : ArrowRight) : null;
        return (React.createElement(Container, __assign({}, this.props),
            remappedChildren,
            IndicatorElement ? React.createElement(IndicatorElement, inav) : null));
    };
    return DefaultTemplate;
}(React.PureComponent));
exports.DefaultTemplate = DefaultTemplate;
exports.template = {
    item: DefaultTemplate,
    children: exports.ChildrenTemplate
};
exports.item = DefaultTemplate;
exports.children = exports.ChildrenTemplate;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-sidenav/template/Default.js
// module id = ./node_modules/react-sidenav/template/Default.js
// module chunks = 0